import { useMutation } from '@tanstack/react-query'
import { brandPayTransaction } from '../../../service/brandpay'

function usePostBrandPayTransaction() {
  return useMutation({
    mutationKey: ['post-brand-pay-transaction'],
    mutationFn: brandPayTransaction,
  })
}

export default usePostBrandPayTransaction
